module.exports = __webpack_public_path__ + "img/tree-03-d-leaves.1c6251e6.png";